import { DitaQueryDetailsFragment } from 'generated/graphql';
import { UpdateDitaQueryState } from 'stores/interfaces/UpdateQueryState';
import { SetState } from 'zustand';

export const createUpdateDitaQuerySlice = (set: SetState<UpdateDitaQueryState>) => ({
  setInitialStateWithProps: (queryDetails: DitaQueryDetailsFragment) =>
    set({
      fileTitle: queryDetails.fileTitle,
      fileName: queryDetails.fileName,
      loio: queryDetails.loio,
      deliverable: queryDetails.deliverable,
      cmsProject: queryDetails.cmsProject,
      submap: queryDetails.submap || undefined,
      xtmProjectName: queryDetails.xtmProjectNameDita || undefined,
      sourceContact: queryDetails.sourceContact
    })
});
